let applyData = {
	front:[
		[
			{name:'市民垃圾投递小程序',appId:'898242e6f04e4e8281419e46b23b036a'},
			{name:'社区督导员APP',appId:'e50c4ce76a8f4e83948da77957bd0f57'},
			{name:'前端设备管控系统',appId:'fe1ba8a6a7a24f46a93cf2b1bb267d1f'},
			{name:'客服监管系统',appId:'acff6905b004444ea4d5b15bd75fbfcd'},
		]
	],
	center:[
		[
			{name:'一体化指挥调度系统',appId:'28b940e6efda4f43a9edf563e6b64bea'},
			{name:'收运司机APP',appId:'092935e6380a4e069bbbbcdbe4108823'},
			{name:'收运设备管控系统',appId:'d730ba1e5aad435facbcc937a09397fd'},
		]
	],
	tailEnd:[
		[
			{name:'财务查询管理系统',appId:'fba24d23b2ae414ba1fdd1794f7bce9e'},
			{name:'餐厨垃圾处理生产管控系统',appId:'49a0c90aa41f4804b50ba7c5d5758946'},
			{name:'厨余垃圾分拣生产管控系统',appId:'070cb565718a451d8e08ae3cad3348e1'},
			{name:'大件园林垃圾破碎生产管控系统',appId:'56406a61dadb441db1a327ae5716e46b'},
			{name:'耗材仓库管理系统',appId:'857eca3904bc46c4b1f9c02fbbb81c44'},
		],
		[
			{name:'化验数据管理系统',appId:'eefe0ef92cd14ee39158a98859af0735'},
			{name:'建筑垃圾破碎生产管控系统',appId:'dac2fcf5cdb14ad9a772cbba372334a3'},
			{name:'垃圾焚烧处理生产管控系统',appId:'c5aedb4d927b448b9cc5e54282da8d74'},
			{name:'能耗监控管理系统',appId:'9e9eca53ca2042e08fab1e311e82a5ca'},
			{name:'生产监督管理APP',appId:'444ff1669fd04cd39313fdac08027982'},
		],
		[
			{name:'污水处理生产管控系统',appId:'20afab0c01284ef78b3b000166079a94'},
			{name:'运营维护APP',appId:'cf1ab233256247d9b34b5f855a9c0674'},
			{name:'制砖车间生产管控系统',appId:'b42f223999c040abb0e9ae858496bf41'},
		]
	],
	basicManage:[
		[
			{name:'基础配置系统',appId:'06a30e0df6d041d0826971e32ebd0d15'},
			{name:'统一认证系统',appId:'cd1144873d4b40819ec3bf238e7008bf'},
			{name:'系统任务调度',appId:'c8eb66783de74e8396bc094862c25558'},
		]
	],
	visual:[
		[
			{name:'垃圾分类一张图--精细化管理及效益看板',appId:'183dc7e33f554fec8a860d54df13102b'},
			{name:'垃圾分类一张图--前中后云端监控看板',appId:'dff78af6246b4de0963619cfa4adc9bb'},
			{name:'垃圾分类一张图--全流程数据看板',appId:'e3037782c8d3457f8e78ebd407edffd6'},
			{name:'生活垃圾调度可视化系统',appId:'addd46f607de4014b73436d0ec0a3820'},
			{name:'数据可视化PAD控屏系统',appId:'b855358b9b44432ebe8290611c8e0127'},
		],
		[
			{name:'智慧园区可视化--能耗监控看板',appId:'7587ce2864aa484282bafb83d3ff77ed'},
			{name:'智慧园区可视化--设备监控看板',appId:'e9b80b248b0d481a9666e77d4aeec5d9'},
			{name:'智慧园区可视化--生产运行监控看板',appId:'6d403a681636489abd5ab8758d072714'},
		]
	],
	other:[
		[
			{name:'城管局固废处置监督管理系统',appId:'27428ec0b7ec47c2aac6dc7fffc2a731'},
			{name:'生活垃圾市级政府监管中心',appId:'da786f959ff642c89dff4f988b39895e'},
			{name:'智慧园区管理系统',appId:'07c4df1ce7ef4b57a30b7f62e9fb3e79'},
		]
	],
}

export default applyData